// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__355w-","buttons":"SendReceipts_buttons__1-P8O","email":"SendReceipts_email__2JGyc","bookApptTitle":"SendReceipts_bookApptTitle__1domw"};